<template>
  <form @submit.prevent="adicionarVSL()">
    <div class="">
      <div class="row">
        <div class="md-2">
          <label class="form-check-label">nome</label>
          <input
            v-model="vsl.vsl_name"
            type="text"
            class="form-control "
            required
          >
        </div>
      </div>
      <div class="divider" />
      <div class="row">
        <div class="md-2">
          <label class="form-check-label">Descrição</label>
          <input
            v-model="vsl.vsl_description"
            type="text"
            class="form-control "
            required
          >
        </div>
      </div>
      <div class="divider" />
      <div class="row">
        <div class="md-2">
          <label class="form-check-label">id usuario</label>
          <input
            v-model="vsl.id_user"
            type="text"
            class="form-control "
            required
          >
        </div>
      </div>
      <div class="divider" />
      <div class="row">
        <div class="md-2">
          <label class="form-check-label">folder</label>
          <input
            v-model="vsl.id_folder"
            type="text"
            class="form-control "
          >
        </div>
      </div>
      <div class="divider" />
      <div class="row">
        <div class="md-2">
          <label class="form-check-label">UrlBucket</label>
          <input
            v-model="vsl.vsl_bucket_address"
            type="text"
            class="form-control "
            required
          >
        </div>
      </div>
      <pre>{{ vsl }}</pre>
    </div>
    <div class="mb-2">
      <input
        type="submit"
        class="btn btn-success"
        value="Criar"
      >
    </div>
  </form>
</template>
<script>

export default {

  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      loading: false,
      vsl: {
        vsl_name: '',
        vsl_description: '',
        id_user: '',
        id_folder: '',
        vsl_bucket_address: '',

      },
      errorMessage: null,

    }
  },

  methods: {
    adicionarVSL() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/vsl`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"vsl_name":"${this.vsl.vsl_name
        }","vsl_description":"${this.vsl.vsl_description
        }","id_user":"${this.vsl.id_user
        }","id_folder":"${this.vsl.id_folder
        }","vsl_bucket_address":"${this.vsl.vsl_bucket_address

        }"}`,
      })

        .then(response => {
          this.$alert('Cadencia adicionada com sucesso.')
          return this.$router.push('')
        })
        .catch(err => console.error(err))
    },

  },
}

</script>
